import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import Colleguebox from "./Colleguebox";
import Colleguegroupebox from "./Colleguegroupebox";
import { Context } from "../../themeContext";
import ReactPaginate from "react-paginate";
import ScaleLoader from "react-spinners/ScaleLoader";
import Switch from "@material-ui/core/Switch";

import { useTranslation, withTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

//const ENDPOINT = "http://192.168.30.40:5004";
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;

function Collegue() {
  const { t } = useTranslation("common");
  //const [collegues, setCollegue] = useState([]);
  const getInitialTheme = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      const storedPrefs = window.localStorage.getItem("advanced-mode");
      if (typeof storedPrefs === "string") {
        return storedPrefs;
      }
    }
    // If you want to use dark theme as the default, return 'dark' instead
    return false;
  };
  const [switchChecked, setSwitchChecked] = useState(getInitialTheme);

  function setSwitch(switchChecked) {
    setSwitchChecked(switchChecked);
    localStorage.setItem("advanced-mode", switchChecked);
  }

  const usePurpleSwitch = () => {
    return {
      root: {
        padding: 7,
      },
      thumb: {
        width: 24,
        height: 24,
        backgroundColor: "#fff",
        //   boxShadow:
        //     "0 0 12px 0 rgba(0,0,0,0.08), 0 0 8px 0 rgba(0,0,0,0.12), 0 0 4px 0 rgba(0,0,0,0.38)",
      },
      switchBase: {
        color: "#00ab00",
        padding: 7,
      },
      colorSecondary: {
        "&$checked": {
          // Controls checked color for the thumb
          color: "#00ab00",
        },
      },
      track: {
        borderRadius: 20,
        backgroundColor: "rgba(0,0,0,0.38)",
        "$checked$checked + &": {
          // Controls checked color for the track
          opacity: 0.7,
          backgroundColor: "#90EE90",
        },
      },
      checked: {
        "& $thumb": {
          backgroundColor: "#fff",
        },
        "& + $track": {
          // opacity: "1 !important",
          backgroundColor: "#00ab00",
        },
      },
      // focusVisible: {},
    };
  };

  const useStyles = makeStyles(usePurpleSwitch());
  const purple = useStyles();

  const [state, dispatch] = useContext(Context);
  const [colleguesPerPage] = useState(60);
  const [offset, setOffset] = useState(1);
  const [collegues, setAllcollegues] = useState([]);
  const [gpcollegues, setAllcolleguesgp] = useState([]);
  const [pageCountgp, setPageCountgp] = useState(0);
  const [offsetgp, setOffsetgp] = useState(1);

  const [pageCount, setPageCount] = useState(0);
  const [collguesforpagination, setPageCollegues] = useState([]);
  const [collguesforpaginationgp, setPageColleguesgp] = useState([]);

  const [loading, setloading] = useState("false");
  const [black1, changeColor1] = useState(
    "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );

  const [black3, changeColor3] = useState(
    "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black4, changeColor4] = useState(
    "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black5, changeColor5] = useState(
    "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  function handleOrangeClick() {
    // Similar to this.setState({ fruit: 'orange' })

    changeColor1(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4   border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor5(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor5(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setPageColleguesgp([]);

    setcollgchoice("con");
    //getAllcollegues();
    setOffset(1);
    //ActiveColor("text-gray-700");
  }

  function handleOrangeClick3() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })
    setcollgchoice("disconnected");
    setPageColleguesgp([]);

    changeColor3(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4   border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );

    changeColor1(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor5(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    //getAllcollegues();
    setOffset(1);
    //ActiveColor("text-gray-700");
  }

  function handleOrangeClick4() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })
    setcollgchoice("all");
    // setPageColleguesgp([]);

    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );

    changeColor1(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor5(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    // getAllcollegues();
    setOffset(1);
    //ActiveColor("text-gray-700");
  }
  function handleOrangeClickgroup() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })
    setcollgchoice("groupecollegue");
    setPageColleguesgp([]);

    changeColor5(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4   border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );

    changeColor1(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    //getAllcollegues();
    setOffset(1);
    //ActiveColor("text-gray-700");
  }
  const length = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {offset * colleguesPerPage}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const length2 = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {collguesforpagination.length}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const lengthgp = () => {
    return (
      <div className="flex">
        {1 + (offsetgp - 1) * colleguesPerPage} - {offsetgp * colleguesPerPage}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpaginationgp.length}
        </div>
      </div>
    );
  };
  const length2gp = () => {
    return (
      <div className="flex">
        {1 + (offsetgp - 1) * colleguesPerPage} -{" "}
        {collguesforpaginationgp.length} {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpaginationgp.length}
        </div>
      </div>
    );
  };

  const getAllcollegues = async () => {
    setloading(true);
    if (collgchoice === "con") {
      //setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesConnecterIPBXV3ApiProfilFiltreParGroupe?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          //console.log(res.data);
          const data = res.data.collegues;
          setPageCollegues(data);
          //  dispatch({ type: "SET_POSTS", payload: data });
          //  console.log(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    // getcontactNames();
    // setAllNames(allcontact.concat(allcollegue));
    else if (collgchoice === "groupecollegue") {
      // setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios

        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/GroupeAppelIPBXV3API?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          //   console.log(res);
          // console.log("Now Names", allNames);
          // console.log(res.data);
          const data = res.data;
          localStorage.setItem("tabgrcollegue", JSON.stringify(data));

          setPageCollegues(data);
          //console.log("all");
          dispatch({ type: "SET_POSTS", payload: data });
          //  setAllcollegues2(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData2(slice);

          // Using Hooks to set value
          setAllcollegues(postData);

          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    } else if (collgchoice === "all") {
      // setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios

        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3ApiProfilFiltreParGroupe
?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          // console.log("Now Names", allNames);
          // console.log(res.data);
          const data = res.data.collegues;
          localStorage.setItem("tabcollegue", JSON.stringify(data));

          setPageCollegues(data);
          //console.log("all");
          dispatch({ type: "SET_POSTS", payload: data });
          //  setAllcollegues2(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);

          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (collgchoice === "disconnected") {
      //  setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesDeconnecterIPBXV3ApiProfilFiltreParGroupe?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          // console.log(res.data);
          const data = res.data.collegues;
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setOffset(selectedPage + 1);
  };
  //const [collegues2, setAllcollegues2] = useState([]);
  function handleresearchui() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })
    setcollgchoice("all");

    changeColor4(
      "mr-8 pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white mr-8 pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );

    changeColor1(
      "dark:text-white mr-8 pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor5(
      "dark:text-white dark:text-white mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setOffset(1);
    //ActiveColor("text-gray-700");
  }

  /////////////////////////////////////////////////:context try////////////////////:
  // const colleguenewarray = () => {
  //   for (var i = 0; i < state.posts.length; i++) {
  //     Object.keys(state.posts[i]).forEach(function (key) {
  //       if (state.posts[i][key] === null) {
  //         // console.log(collegues2[key]);
  //         state.posts[i][key] = "-";
  //       }
  //     });
  //   }
  // };

  const colleguenewarray = (tabcol2) => {
    for (var i = 0; i < tabcol2.length; i++) {
      Object.keys(tabcol2[i]).forEach(function (key) {
        if (tabcol2[i][key] === null) {
          // console.log(collegues2[key]);
          tabcol2[i][key] = "-";
        }
      });
    }
  };
  const [searchText, setSearchText] = useState("");
  const [croix, setcroix] = useState(false);
  const tabcol = localStorage.getItem("tabcollegue");
  const tabgroup = JSON.parse(localStorage.getItem("tabgrcollegue"));
  const tabcol2 = JSON.parse(tabcol);
  //const children = tabcol2.concat(tabgroup);
  const filterData = (value) => {
    handleresearchui();
    // getAllcollegues2();
    // handleOrangeClick4();
    ////////////////////////////collegue///////////////
    const lowercasedValue = value.toLowerCase().trim();
    // const lowercasedValue = searchText.toLowerCase();
    console.log("this lowwwwwwwwwwwwwwer ", lowercasedValue);
    if (lowercasedValue == "") {
      getAllcollegues();
      setPageColleguesgp([]);
    } else {
      colleguenewarray(tabcol2);

      const filteredData = tabcol2.filter((item) => {
        return Object.keys(item).some((key) =>
          item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });

      setPageCollegues(filteredData);
      setOffset(1);

      const slice = filteredData.slice(
        (offset - 1) * colleguesPerPage,
        offset * colleguesPerPage
      );

      const postData = getPostData(slice);

      setAllcollegues(postData);
      setPageCount(Math.ceil(filteredData.length / colleguesPerPage));

      ///////////////////////groupe appel ////////
      colleguenewarray(tabgroup);
      const filteredData2 = tabgroup.filter((item) => {
        return Object.keys(item).some((key) =>
          item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });
      const slice2 = filteredData2.slice(
        (offsetgp - 1) * colleguesPerPage,
        offsetgp * colleguesPerPage
      );
      setPageColleguesgp(filteredData2);
      const postData2 = getPostData2(slice2);
      setAllcolleguesgp(postData2);
      setPageCountgp(Math.ceil(filteredData2.length / colleguesPerPage));
    }
  };

  const handleChange = (value) => {
    //console.log("this is value of research ", value);

    setSearchText(value);
    filterData(value);
  };
  const [collgchoice, setcollgchoice] = useState("con");

  const getPostData = (data) => {
    return data.map((post) => (
      <Colleguebox
        collegue={post}
        key={post.poste}
        avance={switchChecked}
        // etatsocket={posteetatcom}
        //  postesocket={postecom}
      />
    ));
  };
  const getPostData2 = (data) => {
    return data.map((post, i) => <Colleguegroupebox collegue={post} key={i} />);
  };

  useEffect(() => {
    getAllcollegues();
  }, [collgchoice, offset, croix, switchChecked]);

  function test() {
    setSearchText("");
    getAllcollegues();
    setPageColleguesgp([]);
    // console.log("heeeeeeeeeey", searchText);

    setcroix(true);
  }

  useEffect(() => {
    state?.socket?.on("statusChange", (data) => {
      try {
        const parsedData = JSON.parse(data);
        console.log(parsedData);
        if (parsedData.compte !== compte) return;
        setAllcollegues((prev) =>
          prev.map((user) => {
            if (user.key === String(parsedData?.poste)) {
              return {
                ...user,
                props: {
                  ...user.props,
                  collegue: {
                    ...user.props.collegue,
                    status_utilisateur:
                      parsedData?.status_utilisateur?.toString(),
                  },
                },
              };
            } else return user;
          })
        );
      } catch (error) {
        console.log(error);
      }
    });

    return () => {
      state?.socket?.off("statusChange");
    };
  }, [state?.socket]);

  if (loading == false) {
    return (
      <div className="content pb-4 flex flex-col h-screen dark:bg-gray-800 dark:text-white transition-al">
        <div className="py-6 dark:text-white ">
          <div class="dark:text-white md:flex md:items-center md:justify-between mb-8 mx-4">
            <div class="dark:text-white flex-1 min-w-1">
              <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("colleguetitle")}
              </h2>
            </div>
            <div class="dark:text-white flex-1 min-w-1 text-sm text-gray-500 font-bold">
              {" "}
              <Switch
                checked={switchChecked}
                onChange={() => {
                  setSwitch(!switchChecked);
                }}
                classes={purple}
                // color="secondary"
                // className="bg-green-500"
              />{" "}
              {/* <ThemeProvider theme={theme}> */}
              {/* <Switch
                  checked={state.checkedA}
                  onChange={handleChange}
                  name="checkedA"
                /> */}
              {/* <Switch
                  checked={switchChecked}
                  onChange={() => {
                    setSwitchChecked(!switchChecked);
                  }} */}
              {/* />{" "} */}
              {/* </ThemeProvider> */}
              {t("mode.avance")}
            </div>
            <div className="mt-1 relative rounded-md shadow-sm dark:text-white transition-al ">
              <input
                type="text"
                className="dark:bg-gray-600 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("trouvercollegue")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />{" "}
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none dark:text-gray-100 transition-al">
                <svg
                  className="h-5 w-5 text-gray-400  "
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              {searchText != "" ? (
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center dark:text-gray-100 transition-al hover:bg-gray-100"
                  onClick={() => {
                    test();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          {/* <div className=" border-b border-gray-200 flex dark:text-white transition-al"> */}
          <div className="dark:border-gray-800 border-b border-gray-200 dark:text-white transition-al">
            {collguesforpagination.length !== 0 ? (
              <div className="flex">
                <div
                  className="flex"
                  style={{ marginLeft: "auto", order: "2" }}
                >
                  <span
                    className="text-gray-500 dark:text-white"
                    //  style={{ marginLeft: "auto", order: "2" }}
                  >
                    {collguesforpagination.length != 0
                      ? offset == pageCount
                        ? length2()
                        : length()
                      : console.log("length 0")}
                  </span>

                  <ReactPaginate
                    previousLabel={"<"}
                    previousClassName={
                      "p-0.5 md:p-1.5 lg:p-1.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center  border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    nextLabel={">"}
                    nextClassName={
                      "pl-1.5 lg:pl-2.5 md:pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    breakLabel={"countforpagination"}
                    breakClassName={"hidden"}
                    pageClassName={
                      "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                    }
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "relative z-0 inline-flex rounded-md  -space-x-px"
                    }
                    activeClassName=""
                    forcePage={offset - 2}
                  />
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <nav className="flex-1 min-w-2" aria-label="Tabs">
              <a
                href="#"
                className={black4}
                onClick={() => handleOrangeClick4()}
              >
                {/* <User
                  className="text-gray-500 group-hover:text-gray-500 dark:text-white transition-al
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("allcollegue")}
                </span>
                <span className="lg:hidden md:hidden">{t("all.media")}</span>
              </a>

              <a
                href="#"
                className={black1}
                onClick={() => handleOrangeClick()}
              >
                {/* <User
                  className="text-green-600 group-hover:text-gray-500
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("connectedcollegue")}
                </span>
                <span className="lg:hidden md:hidden">
                  {t("connected.media")}
                </span>
              </a>

              <a
                href="#"
                className={black3}
                aria-current="page"
                onClick={() => handleOrangeClick3()}
              >
                {/* <User
                  className="text-gray-500 group-hover:text-gray-500 dark:text-white 
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("disconnectedcollegue")}
                </span>
                <span className="lg:hidden md:hidden">
                  {t("disconnected.media")}
                </span>
              </a>
              <a
                href="#"
                className={black5}
                onClick={() => handleOrangeClickgroup()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("groupe.appel")}
                </span>
                <span className="lg:hidden md:hidden">{t("groupe")}</span>
              </a>
            </nav>
          </div>
        </div>
        {collguesforpagination.length !== 0 ? (
          <div className="overflow-y-auto grid grid-cols-1 gap-4 lg:grid-cols-3 sm:grid-cols-1 md:grid-cols-2 mt-4 ">
            {collegues}
          </div>
        ) : (
          <div className="justify-center mt-64 pr-96">
            <h2 className=" pl-44 dark:text-white text-lg font-medium leading-7  sm:text-3xl sm:truncate text-gray-400">
              {t("NoColleagues")}
            </h2>
          </div>
        )}

        {collguesforpaginationgp.length !== 0 ? (
          <div class="dark:text-white  min-w-1 mt-16">
            <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
              {t("groupe.appel")}
            </h2>
            <div className="dark:border-gray-800 border-b border-gray-200 dark:text-white transition-al">
              {collguesforpaginationgp.length !== 0 ? (
                <div className="flex">
                  <div
                    className="flex"
                    style={{ marginLeft: "auto", order: "2" }}
                  >
                    <span
                      className="text-gray-500 dark:text-white"
                      //  style={{ marginLeft: "auto", order: "2" }}
                    >
                      {collguesforpaginationgp.length != 0
                        ? offsetgp == pageCountgp
                          ? length2gp()
                          : lengthgp()
                        : console.log("length 0")}
                    </span>

                    <ReactPaginate
                      previousLabel={"<"}
                      previousClassName={
                        "p-0.5 md:p-1.5 lg:p-1.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center  border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                      }
                      nextLabel={">"}
                      nextClassName={
                        "pl-1.5 lg:pl-2.5 md:pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                      }
                      breakLabel={"countforpagination"}
                      breakClassName={"hidden"}
                      pageClassName={
                        "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                      }
                      pageCount={pageCountgp}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "relative z-0 inline-flex rounded-md  -space-x-px"
                      }
                      activeClassName=""
                      forcePage={offset - 2}
                    />
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
            <div className="overflow-y grid grid-cols-1 gap-4 lg:grid-cols-3 sm:grid-cols-1 md:grid-cols-2 mt-4 ">
              {console.log("grouuuuuuuuuuuuuuupe", gpcollegues)}
              {gpcollegues}
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  } else {
    return (
      <div className="content pb-4 flex flex-col h-screen dark:bg-gray-800 dark:text-white transition-al">
        <div className="py-6">
          <div class="md:flex md:items-center md:justify-between mb-8 mx-4">
            <div class="flex-1 min-w-1">
              <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("colleguetitle")}
              </h2>
            </div>
            <div class="dark:text-white flex-1 min-w-1 text-sm text-gray-500 font-bold">
              {" "}
              <Switch
                checked={switchChecked}
                onChange={() => {
                  setSwitch(!switchChecked);
                }}
                classes={purple}
                //color="secondary"
              />{" "}
              {t("mode.avance")}
            </div>
            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                className="dark:bg-gray-600  focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("trouvercollegue")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />{" "}
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
          {/* <div className=" dark:border-gray-800 border-b border-gray-200 flex">
            <nav className="flex-1 min-w-2 " aria-label="Tabs">
              <a
                href="#"
                className={black4}
                onClick={() => handleOrangeClick4()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("allcollegue")}
                </span>
                <span className="lg:hidden md:hidden">{t("all.media")}</span>
              </a>

              <a
                href="#"
                className={black1}
                onClick={() => handleOrangeClick()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("connectedcollegue")}
                </span>
                <span className="lg:hidden md:hidden">
                  {t("connected.media")}
                </span>
              </a>

              <a
                href="#"
                className={black3}
                aria-current="page"
                onClick={() => handleOrangeClick3()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("disconnectedcollegue")}
                </span>
                <span className="lg:hidden md:hidden">
                  {t("disconnected.media")}
                </span>
              </a>
              <a
                href="#"
                className={black5}
                onClick={() => handleOrangeClickgroup()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("groupe.appel")}
                </span>
                <span className="lg:hidden md:hidden">{t("groupe")}</span>
              </a>
            </nav>
            <div className="flex -ml-4"></div>
          </div> */}

          <div className="flex flex-wrap justify-center mt-64 overflow-y-auto">
            <ScaleLoader
              color="#109669"
              loading={loading}
              size={50}
              width={4}
              height={68}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation("common")(Collegue);
